module.exports = __webpack_public_path__ + "static/media/mic_mute.03ef12e7.svg";